// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31Jc4","title":"styles_title__1ZwKE"};